import React from 'react'
import styles from './CarImageHeader.module.css'

const CarImageHeader = () =>
  <div className={styles.carImageHeader} />

export default CarImageHeader
